export default function trim(value: string, trimLength: number, condition: boolean):string {
  return condition ? value.slice(0, trimLength) : value
}
